export enum TipoControlloCoerenza {
    ControlloCodiciATECO = 0,
    ControlloResidenza = 1,
    ControlloCCIAA = 2,
    ControlloUltimoUNICO = 3,
    ControlloCrediti = 4,
    ControlloAltriRedditi = 5,
    ControlloContribuzione = 6,
    ControlloScaricoUNICO = 8,
    ControlloPercentualeImposta = 9,
    ControlloAltriAcconti = 10,
    ControlloLimiteFatturato = 11,
    ControlloLimitiForfettari = 12,
    impostaAliquota = 13,
    ControlloScaricamentoEdElaborazioneF24 = 14,
    ControlloScaricamentoRateInps = 16,
    ControlloScaricamentoPosizioneInps = 17,
    ControlloNotificaDichiarazioneUtente = 18,
    ControlloNotificaDichiarazioneUtenteSenzaRisposta = 19,
    ControlloImposte = 20,
    ControlloSedeEMatricolaInps = 21,
    ControlloNotificaPreliminareDichiarazioneNonGestita = 22,
    ControlloNotificaPreliminareDichiarazioneMancante = 23,
    ControlloNotificaConfermaDichiarazioneNonGestita = 24,
    ControlloNotificaConfermaDichiarazioneMancante = 25,
    ControlloNotificaIncassiFattureNonGestita = 26,
    ControlloVerificaDelegheInps = 27,
    ControlloAggiornamentoDatiINPS = 28,
    ControlloCorrettezzaContribuzione = 29,
    ControlloVerificaDelegaCassettoFiscale = 1000,
    ControlloVerificaDelegaFatturazioneElettronica = 1001,
    ControlloVerificaDelegaAgenziaEntrateRiscossione = 1003,
    ControlloFattureImportateDaUtente = 1050,
}

export enum EsitoControllo {
    Ok,
    Warning,
    Errore,
}

export const esitoControlloLookUp = [
    { value: EsitoControllo.Ok, description: 'OK' },
    { value: EsitoControllo.Warning, description: 'Warning' },
    { value: EsitoControllo.Errore, description: 'Errore' },
];

export interface Esito {
    displayName: string;
    id: EsitoControllo;
}

export interface Tipo {
    displayName: string;
    id: number;
}

export interface VerificaOperatore {
    data?: Date;
    annotazioni: string;
    operatoreId?: number;
    isEseguita: boolean;
}

export interface EventoControlloCoerenza {
    id: number;
    codiceFiscale: string;
    cognome: string;
    nome: string;
    data: Date;
    tipo: Tipo;
    controlloOperatore: VerificaOperatore;
    esito: Esito;
}

export interface EventoControlloCoerenzaVm extends EventoControlloCoerenza {
    nominativo: string;
}

export interface VerificaDaOperatoreResult {
    verificaOperatore: VerificaOperatore;
    cassettoFiscaleAffidabile: boolean;
}

export interface ControlloCoerenza {
    id: number;
    tipo: Tipo;
    data: Date;
    dataFineControllo: Date;
    esito: Esito;
    dettagli: ControlliCoerenzaDettagli[];
    verificaOperatore: VerificaOperatore;
    riferimento: number;
    extraInfo: any;
}

export interface ControlliCoerenzaDettagli {
    id: number;
    controlliCoerenzaId: number;
    esito: Esito;
    annotazioni: string;
}

export interface EventoEsito extends Esito {}

export enum TipiEventoControllo {
    AttivazioneCassettoFiscale = 0,
    ScaricamentoRateInps = 1,
    NotificaPreliminareDichiarazioneUtente = 2,
    VerificaDelegheInps = 3,
    AggiornamentoDatiINPS = 4,
    ValidazioneDichiarazioni = 5,
}

export class EventoTipo implements Tipo {
    public static readonly AttivazioneCassettoFiscale: EventoTipo = new EventoTipo(
        TipiEventoControllo.AttivazioneCassettoFiscale,
        'Prima attivazione cassetto fiscale'
    );
    public static readonly ScaricamentoRateInps: EventoTipo = new EventoTipo(TipiEventoControllo.ScaricamentoRateInps, 'Scaricamento rate Inps');
    public static readonly NotificaPreliminareDichiarazioneUtente: EventoTipo = new EventoTipo(
        TipiEventoControllo.NotificaPreliminareDichiarazioneUtente,
        'Notifica Preliminare Dichiarazione Utente'
    );
    public static readonly VerificaDelegheInps: EventoTipo = new EventoTipo(TipiEventoControllo.VerificaDelegheInps, 'Verifica delege INPS');
    public static readonly AggiornamentoDatiINPS: EventoTipo = new EventoTipo(TipiEventoControllo.AggiornamentoDatiINPS, 'Aggiornamento dai INPS');
    public static readonly ValidazioneDichiarazioni: EventoTipo = new EventoTipo(TipiEventoControllo.ValidazioneDichiarazioni, 'Validazione dichiarazioni');

    constructor(public id: number, public displayName: string) {}
}

export interface ControlloTipo extends Tipo {}

export interface ControlloEsito extends Esito {}

export interface ControlloCoerenzaBase {
    codiceFiscale: string;
    nominativo: string;
    partitaIva: string;

    controlloId: number;
    controlloTipo: ControlloTipo;
    controlloData: Date;
    controlloDataFine: Date;
    controlloEsito: ControlloEsito;
    controlloRiferimento: number;
    controlloRimpiazzato: boolean;
    controlloAnnotazioni: string;
    /**
     * Flag esposto dal backend sul controllo di correttezza contribuzione:
     * se true, l'errore è stato marcato come "gestito" nella contribuzione della dichiarazione
     * e l'elemento va mostrato nella scheda "Gestiti" anziché in "Da gestire".
     */
    ignoraErroreInps?: boolean;

    dataInizioIva: string | Date;

    eventoId: number;
    eventoTipo: EventoTipo;
    eventoData: Date;
    eventoDescrizione: string;
    eventoEsito: EventoEsito;
    eventoRimpiazzatoDaId?: number;
}

export interface ControlloCoerenzaElenco extends ControlloCoerenzaBase {
    controlloVerificaAnnotazioni: string;
    controlloVerificaData?: Date;
    controlloVerificaOperatoreId?: number;

    eventoVerificaAnnotazioni: string;
    eventoVerificaData?: Date;
    eventoVerificaOperatoreId?: number;
}

export interface ControlloCoerenzaElencoModel extends ControlloCoerenzaBase {
    controlloVerifica?: VerificaOperatore;
    eventoVerifica?: VerificaOperatore;
}
